export const AVAILABLE_SUPPORTED_CURRENCIES = {
  EURO: 'EUR',
  USD: 'USD',
} as const;

export const ArrayOfAvailableSupportedCurrencies = Object.values(AVAILABLE_SUPPORTED_CURRENCIES);

export const DEFAULT_CURRENCY = AVAILABLE_SUPPORTED_CURRENCIES.EURO;
